(function(){
  // mobile menu
  var burger=document.getElementById('burger');
  if(burger){burger.addEventListener('click',function(){
    var o=document.body.classList.toggle('menu-open');
    burger.setAttribute('aria-expanded',o);
  });
  var m=document.getElementById('mobile');
  if(m){m.addEventListener('click',function(e){if(e.target.tagName==='A'){document.body.classList.remove('menu-open');burger.setAttribute('aria-expanded','false');}});}}

  // FAQ accordion
  document.querySelectorAll('.faq-acc').forEach(function(acc){
    acc.addEventListener('click',function(e){
      var q=e.target.closest('.q'); if(!q)return;
      var open=q.getAttribute('aria-expanded')==='true';
      acc.querySelectorAll('.q').forEach(function(b){b.setAttribute('aria-expanded','false');b.nextElementSibling.style.maxHeight=null;});
      if(!open){q.setAttribute('aria-expanded','true');var a=q.nextElementSibling;a.style.maxHeight=a.scrollHeight+'px';}
    });
  });

  // hero reveal
  var h=document.getElementById('hero-in'); if(h){requestAnimationFrame(function(){h.classList.add('in');});}

  // product: variant select -> price + availability + add btn
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var jsonEl=form.querySelector('[data-variants-json]');
    var data=[];
    try{ data=JSON.parse(jsonEl?jsonEl.textContent:(form.getAttribute('data-variants')||'[]')); }catch(e){ data=[]; }
    var selects=form.querySelectorAll('[data-opt]');
    var idInput=form.querySelector('[name="id"]');
    var priceEl=document.querySelector('[data-price]');
    var addBtn=form.querySelector('[data-add]');
    var stockEl=document.querySelector('[data-stock]');
    function money(c){return '$'+(c/100).toFixed(2);}
    function update(){
      if(!selects.length)return; /* single-variant: keep the server-rendered id + button */
      var chosen=[].map.call(selects,function(s){return s.value;});
      if(chosen.some(function(x){return x==='';})){ /* a size/option not chosen yet */
        if(idInput)idInput.value='';
        if(addBtn){addBtn.disabled=true;addBtn.textContent='Select an option';}
        return;
      }
      var v=data.find(function(x){return x.options.join('~~')===chosen.join('~~');});
      if(!v){ if(idInput)idInput.value=''; if(addBtn){addBtn.disabled=true;addBtn.textContent='Unavailable';} return; }
      idInput.value=v.id;
      if(priceEl)priceEl.innerHTML=money(v.price)+(v.compare&&v.compare>v.price?'<span class="compare">'+money(v.compare)+'</span>':'');
      if(v.available){addBtn.disabled=false;addBtn.textContent='Add to cart';if(stockEl){stockEl.className='stock-tag in';stockEl.textContent='In Stock';}}
      else{addBtn.disabled=true;addBtn.textContent='Sold out';if(stockEl){stockEl.className='stock-tag out';stockEl.textContent='Sold Out';}}
    }
    selects.forEach(function(s){s.addEventListener('change',update);});
    update();
  });

  /* product-card image gallery: arrows cycle a card's photos (delegated) */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-cg]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();
    var thumb=btn.closest('.thumb');if(!thumb)return;
    var imgs=thumb.querySelectorAll('.cg-img');if(imgs.length<2)return;
    var cur=0;for(var i=0;i<imgs.length;i++){if(imgs[i].classList.contains('is-active')){cur=i;break;}}
    var dir=parseInt(btn.getAttribute('data-cg'),10)||1;
    var next=(cur+dir+imgs.length)%imgs.length;
    imgs[cur].classList.remove('is-active');imgs[next].classList.add('is-active');
    var dots=thumb.querySelectorAll('.cg-dot');
    if(dots.length){for(var d=0;d<dots.length;d++){dots[d].classList.toggle('is-active',d===next);}}
    if(btn.blur)btn.blur();
  },false);
  /* keyboard access for the span-based arrows */
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ')return;
    var a=e.target.closest&&e.target.closest('[data-cg],[data-pd-arrow]');
    if(a){e.preventDefault();a.click();}
  },false);

  // product page: main image, thumbnails + overlay arrows
  (function(){
    var thumbs=[].slice.call(document.querySelectorAll('[data-thumb]'));
    var main=document.querySelector('[data-main-img]');
    if(!main||!thumbs.length)return;
    var cur=0;
    function show(i){
      cur=(i+thumbs.length)%thumbs.length;
      main.src=thumbs[cur].getAttribute('data-full');
      for(var k=0;k<thumbs.length;k++){thumbs[k].classList.toggle('is-active',k===cur);}
    }
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){show(k);});});
    document.querySelectorAll('[data-pd-arrow]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        show(cur+(parseInt(btn.getAttribute('data-pd-arrow'),10)||1));
        if(btn.blur)btn.blur();
      });
    });
    show(0);
  })();

  /* Colour picker drives the main photo.
     Its own listener, and deliberately placed after the thumbnail block, because that block owns
     main.src and calls show(0) on load. Putting this inside the variant-matching code did not
     work: that only resolves an image once BOTH options match a real variant, and sizes start
     unselected on purpose, so in the state that matters most, colour chosen and no size yet, it
     had nothing to show and left the first colour up.
     Keying off the first option alone fixes that. OGO assigns one photo per colour, so every size
     of a colour resolves to the same photo and picking a size never flaps the image. */
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var jsonEl=form.querySelector('[data-variants-json]');
    var mainImg=document.querySelector('[data-main-img]');
    var first=form.querySelector('[data-opt]');
    if(!jsonEl||!mainImg||!first)return;
    var data=[];
    try{ data=JSON.parse(jsonEl.textContent); }catch(e){ return; }
    if(!data.some(function(x){return x.img;}))return;   // nothing per-variant to show
    first.addEventListener('change',function(){
      for(var i=0;i<data.length;i++){
        if(data[i].options[0]===first.value&&data[i].img){ mainImg.src=data[i].img; return; }
      }
    });
  });

  // quick add to cart (product cards)
  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    var orig=btn.innerHTML;
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var id=btn.getAttribute('data-variant-id');
      if(!id||btn.disabled)return;
      btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){
          btn.classList.add('added');
          btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l4 4 10-10"/></svg>';
          return fetch('/cart.js').then(function(r){return r.json();});
        })
        .then(function(cart){
          if(cart){document.querySelectorAll('[data-cart-count-wrap]').forEach(function(el){el.innerHTML=cart.item_count>0?'<span class="cart-badge">'+cart.item_count+'</span>':'';});}
          setTimeout(function(){btn.classList.remove('added');btn.innerHTML=orig;btn.disabled=false;},1600);
        })
        .catch(function(){btn.classList.remove('added');btn.innerHTML=orig;btn.disabled=false;});
    });
  });

  // footer year
  var yr=document.getElementById('yr'); if(yr)yr.textContent=new Date().getFullYear();
})();

/* Facebook live feed -> social grid (falls back to manual posts on any error) */
(function(){
  function initFB(){
    var grid=document.querySelector('[data-fb-feed]');
    if(!grid)return;
    var url=grid.getAttribute('data-fb-feed');
    if(url&&!/^https?:\/\//i.test(url))url='https://'+url; /* tolerate a scheme-less feed URL */
    var count=parseInt(grid.getAttribute('data-fb-count')||'4',10);
    function esc(s){return (s||'').replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
    fetch(url).then(function(r){return r.json();}).then(function(d){
      var posts=(d&&d.posts)||[];
      if(!posts.length)return;
      var html=posts.slice(0,count).map(function(p){
        var msg=(p.message||'').trim(),title,exc;
        if(msg){
          var nl=msg.indexOf('\n');
          if(nl>0&&nl<70){title=msg.slice(0,nl);exc=msg.slice(nl+1).trim();}
          else{var m=msg.search(/[.!?]\s/);if(m>0&&m<80){title=msg.slice(0,m+1);exc=msg.slice(m+1).trim();}else{title=msg.slice(0,70);exc=msg.length>70?msg.slice(70).trim():'';}}
        }else{title='New from Torque';exc='';}
        if(title.length>70)title=title.slice(0,70).trim()+'\u2026';
        if(exc.length>140)exc=exc.slice(0,140).trim()+'\u2026';
        /* CSS-escape only what url() needs; encodeURI would double-encode %-escaped URLs (e.g. FB ad images) */
        var cssUrl=(p.image||'').replace(/["'()\\ ]/g,function(c){return ({'"':'%22',"'":'%27','(':'%28',')':'%29','\\':'%5C',' ':'%20'})[c];});
        var img=p.image?(' style="background-image:url('+cssUrl+');background-size:cover;background-position:center"'):'';
        var cam=p.image?'':'<svg class="cam" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.6"><rect x="3" y="6" width="18" height="13" rx="2"/><circle cx="12" cy="12.5" r="3.2"/><path d="M8 6l1.5-2h5L16 6"/></svg>';
        return '<a class="post" href="'+esc(p.link||'#')+'" target="_blank" rel="noopener"><div class="ph"'+img+'>'+cam+'<span class="tagwrap"><span class="tag">View full post</span></span></div><h4>'+esc(title)+'</h4><p>'+esc(exc)+'</p></a>';
      }).join('');
      grid.innerHTML=html;
      /* Adaptive "View full post" chip: sample each graphic; if it is mostly
         red, flip the chip to white-with-red-text so it stays visible. */
      try{
        var phs=grid.querySelectorAll('.post .ph');
        posts.slice(0,count).forEach(function(p,i){
          if(!p.image||!phs[i])return;
          var tag=phs[i].querySelector('.tag'); if(!tag)return;
          var im=new Image(); im.crossOrigin='anonymous';
          im.onload=function(){
            try{
              var n=24,c=document.createElement('canvas');c.width=n;c.height=n;
              var x=c.getContext('2d');x.drawImage(im,0,0,n,n);
              var d=x.getImageData(0,0,n,n).data,red=0;
              for(var j=0;j<d.length;j+=4){
                var r=d[j],g=d[j+1],b=d[j+2];
                if(r>90&&r>g*1.55&&r>b*1.55)red++;
              }
              if(red/(n*n)>0.32)tag.classList.add('tag--inv');
            }catch(e){/* CORS or decode issue: keep default red chip */}
          };
          im.src=p.image;
        });
      }catch(e){}
    }).catch(function(){/* keep manual posts */});
  }
  if(document.readyState!=='loading')initFB();else document.addEventListener('DOMContentLoaded',initFB);
})();

/* Leave a Review — star rating selector */
(function(){
  function init(){
    var box=document.querySelector('[data-rating-stars]');
    if(!box)return;
    var input=document.getElementById('ratingInput');
    var lbl=document.querySelector('[data-rate-label]');
    var stars=box.querySelectorAll('.star');
    var words=['','Poor','Fair','Good','Great','Excellent'];
    stars.forEach(function(s){
      s.addEventListener('click',function(){
        var v=+s.dataset.i; if(input)input.value=v;
        stars.forEach(function(x){x.classList.toggle('on',+x.dataset.i<=v);});
        if(lbl)lbl.textContent=words[v]+' \u2014 '+v+'/5';
      });
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
